import React, { useState } from "react";
import { useParams } from "react-router";

import TeamMembersList from "./TeamMembersList";

import LoadingSpinner from "../../../../common/LoadingSpinner";
import RequestCompleteNotice from "../../../../common/settings-modal/RequestCompleteNotice";

import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";
import { getMember } from "../../../../redux/reducers/team";
import {
  updateOwnDBEntry,
  getUserId,
  requestDBEntryApproval,
} from "../../../../redux/reducers/user";

import { PageVisibility } from "../../../../utils/PageVisibility";
import { useGetTeamMembers, useGetTeams } from "../../../../utils/useTeam";

const TeamMembersContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isComplete, setIsComplete] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const auth_token = useAppSelector(getAuthToken);
  const ownerId = useAppSelector(getUserId);

  const { members, isLoading: getLoading } = useGetTeamMembers({
    id,
    auth_token,
  });

  const {
    items: { teams },
  } = useGetTeams({ id, auth_token });
  const team = teams[0];

  const completeHandler = () => {
    setIsComplete(false);
  };

  const handlePrivate = async (requestId?: string) => {
    if (auth_token && requestId) {
      setIsLoading(true);

      await dispatch(
        updateOwnDBEntry({
          auth_token,
          id: requestId,
          update: {
            sonic_status: PageVisibility.NotPubliclyVisible,
          },
        })
      );

      dispatch(getMember({ id: id, auth_token: auth_token })).finally(() =>
        setIsLoading(false)
      );
    }
  };

  const handlePublish = async (requestId?: string) => {
    if (auth_token && requestId) {
      setIsLoading(true);

      await dispatch(
        requestDBEntryApproval({ auth_token: auth_token, id: requestId })
      ).finally(() => {
        setIsComplete(true);
      });

      dispatch(getMember({ id: id, auth_token: auth_token })).finally(() =>
        setIsLoading(false)
      );
    }
  };

  if (isComplete) {
    return (
      <RequestCompleteNotice
        handler={completeHandler}
        backBarText="プロフィール"
        title="公開申請完了"
        text={
          "公開申請が完了しました。\nこれより審査を開始します。\n結果通知までしばらくお待ちください。"
        }
        sub_text="※内容によっては数日お時間をいただく可能性がございます。"
      />
    );
  } else if (isLoading || getLoading) {
    return <LoadingSpinner space={1} />;
  } else {
    return (
      <TeamMembersList
        backBarTitle={team?.name}
        members={members}
        ownerId={ownerId}
        handlePublish={handlePublish}
        handlePrivate={handlePrivate}
      />
    );
  }
};

export default TeamMembersContainer;
